import { MonoTypeOperatorFunction, shareReplay } from 'rxjs';

/**
 * A shortcut for shareReplay bufferSize = 1, refCount = true
 */
export function elioShareReplay<T>(): MonoTypeOperatorFunction<T> {
  return shareReplay({ bufferSize: 1, refCount: true });
}
